export default __webpack_public_path__ + "static/media/map-phone.032b708f.webp";